import { NgModule }                     from '@angular/core';
import { RouterModule, Routes }         from '@angular/router';


import { ForgotPasswordComponent}       from './forgot-password/forgot-password.component';
import { SignInComponent }               from './sign-in/sign-in.component';
import { DashboardComponent }            from './Dashboard/dashboard.component';
import { ReportOverviewComponent }       from './Dashboard/DashboardPages/report-overview/report-overview.component';
import { MailSentComponent }              from './mail-sent/mail-sent.component';
import { CreateUserComponent }             from './Dashboard/DashboardPages/User management/create-user/create-user.component';
import { ManageUsersComponent }            from './Dashboard/DashboardPages/User management/manage-agents/manage-users.component';
import { CreateAdminComponent }            from './Dashboard/DashboardPages/User management/create-admin/create-admin.component';
import { NewPasswordComponent }  from './new-password/new-password.component';
import { CreateRoleComponent }  from './Dashboard/DashboardPages/Role management/create-role/create-role.component';
import { ManageRoleComponent }  from './Dashboard/DashboardPages/Role management/manage-role/manage-role.component';
import { EditRoleComponent }  from './Dashboard/DashboardPages/Role management/edit-role/edit-role.component';
import { AdminProfileComponent }  from './Dashboard/DashboardPages/User management/admin-profile/admin-profile.component';
import { AdminChangePasswordComponent }  from './Dashboard/DashboardPages/User management/admin-change-password/admin-change-password.component';
import { UserProfileComponent }  from './Dashboard/DashboardPages/User management/user-page/user-profile.component';
import { UserAgentsComponent }  from './Dashboard/DashboardPages/User management/user-page/user-agents/user-agents.component';
import { AgentProfileComponent }  from './Dashboard/DashboardPages/User management/user-page/agent-account/agent-account.component';
import { ManageAdminComponent }  from './Dashboard/DashboardPages/User management/manage-admin/manage-admin.component';
import { PermissionsComponent }  from './Dashboard/DashboardPages/User management/user-page/permissions/permissions.component';
import { ManageCustomersComponent } from './Dashboard/DashboardPages/User management/manage-customers/manage-customers.component';
import { QuickFundingComponent } from './Dashboard/DashboardPages/funding/quick-funding/quick-funding.component';
import { FundRequestsComponent } from './Dashboard/DashboardPages/funding/fund-requests/fund-requests.component';
import { FundHistoryComponent } from './Dashboard/DashboardPages/funding/fund-history/fund-history.component';
import { AirtimeComponent } from './Dashboard/DashboardPages/Transactions/airtime/airtime.component';
import { WalletComponent } from './Dashboard/DashboardPages/transactions/wallet/wallet.component';
import { Page500Component } from './error-pages/page-500/page-500.component';
import { Page404Component } from './error-pages/page-404/page-404.component';
import { AuthGuard } from './services/Auth-guard/auth.guard';
import {FundAgentsComponent} from './Dashboard/DashboardPages/funding/fund-agents/fund-agents.component';
import {FrozenAccountsComponent} from 'app/Dashboard/DashboardPages/frozen-accounts/frozen-accounts.component';
import {CustomerProfileComponent} from './Dashboard/DashboardPages/User management/user-page/customer-account/customer-account.component';
import { AdminAccountComponent } from './Dashboard/DashboardPages/User management/user-page/admin-account/admin-account.component';
import { NetworksConfigurationComponent } from './Dashboard/DashboardPages/networks-configuration/networks-configuration.component';
import {DataComponent} from './Dashboard/DashboardPages/Transactions/data/data.component';
import {TransactionsConfigurationComponent} from './Dashboard/DashboardPages/transactions-configuration/transactions-configuration.component';


const agent: Routes = [
  { path: 'view_profile/:id', component: UserProfileComponent},
  { path: 'view-agents/:id', component: UserAgentsComponent }
]


const admin: Routes = [
  { path: 'dashboard', component: ReportOverviewComponent },
  { path: 'reset-password', component: ForgotPasswordComponent },
  { path: 'create-user', component: CreateUserComponent },
  { path: 'create-admin', component: CreateAdminComponent },
  { path: 'manage-admin', component: ManageAdminComponent },
  { path: 'manage-agents', component: ManageUsersComponent },
  { path: 'manage-networks', component: NetworksConfigurationComponent},
  { path: 'transactions-configuration', component: TransactionsConfigurationComponent},
  { path: 'frozen-accounts', component: FrozenAccountsComponent },
  { path: 'manage-customers', component: ManageCustomersComponent },
  { path: 'airtime-transactions', component: AirtimeComponent },
  { path: 'data-transactions', component: DataComponent },
  { path: 'wallet-transactions', component: WalletComponent },
  { path: 'create-role', component: CreateRoleComponent },
  { path: 'fund-agents', component: FundAgentsComponent },
  { path: 'quick-funding', component: QuickFundingComponent },
  { path: 'fund-requests', component: FundRequestsComponent },
  { path: 'fund-history', component: FundHistoryComponent },
  { path: 'manage-role', component: ManageRoleComponent },
  { path: 'edit-role/:id', component: EditRoleComponent },
  { path: 'profile', component: AdminProfileComponent },
  { path: 'change-password', component: AdminChangePasswordComponent },
  { path: 'profile/:id', component: UserProfileComponent,
    children: [
      { path: 'view', component: AdminAccountComponent},
      { path: 'permissions', component: PermissionsComponent }
    ]
  },
  { path: 'agent/:id', component: UserProfileComponent,
    children: [
      { path: 'account', component: AgentProfileComponent},
      { path: 'user-agents', component: UserAgentsComponent },
      { path: 'permissions', component: PermissionsComponent }
    ]
  },
  { path: 'customer/:id', component: UserProfileComponent,
    children: [
      { path: 'account', component: CustomerProfileComponent},
    ]
  }
  // { path: '**', component: PageNotFoundComponent },
];

const error: Routes = [
  { path: 'page-404', component: Page404Component },
  { path: 'page-500', component: Page500Component },
];


/////////////////////////////////////// Base routes ///////////////////////////////////////////////////////////////////
const routes: Routes = [
  {
    path: '',
    redirectTo: '/admin/dashboard',
    pathMatch: 'full'
  },
  { path: 'page-500', component: Page500Component, },
  { path: 'page-404', component: Page404Component, },
  {
    path: 'admin',
    component: DashboardComponent,
    children: admin,
    canActivate: [AuthGuard]
  },


  {
    path: 'sign-in',
    component: SignInComponent,
  },

  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },

  {
    path: 'new-password/:token',
    component: NewPasswordComponent,
  },

  {
    path: 'mail-sent',
    component: MailSentComponent
  },

  // {
  //   path: 'error',
  //   component: ExtraLayoutComponent,
  // },
  {
    path: '**',
    component: Page404Component,
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts